module.exports = __webpack_public_path__ + "img/history.08b33c9a.png";